module.exports = __webpack_public_path__ + "static/media/mesa-logo.85002096.png";